import { useState } from "react";
import Collapse from "react-bootstrap/Collapse";
import { FormattedMessage } from "react-intl";
import { ElectrodesStatus } from "../../../../api/index.defs";

import { Button } from "@shltelemedicine/shl-ui-lib";
import InfoIcon from "../../../Shared/InfoIcon/InfoIcon";
import MetaCard from "../MetaCard/MetaCard";

import styles from "./Electrodes.module.css";

type ElectrodesProps = {
  electrodes: ElectrodesStatus;
  compare?: boolean;
};

const Electrodes = ({ electrodes, compare }: ElectrodesProps) => {
  const [showInfo, setShowInfo] = useState(false);

  const entries = Object.entries(electrodes);

  return (
    <MetaCard compare={compare}>
      <div className="font-md">
        <header className="d-flex flex-wrap justify-content-between align-items-center mb-3">
          <p className="mb-0 prim-color-dark font-weight-bold">
            <FormattedMessage
              id="ECG_DETAILS.ELECTRODES"
              defaultMessage="Electrodes"
            />
            :
          </p>
          <div className="d-flex align-items-center font-sm">
            {entries.map(([key, value]) => (
              <div
                key={key}
                className={`p-1 mx-sm text-white text-center ${
                  value ? styles.on : styles.off
                }`}
              >
                {key?.toUpperCase()}
              </div>
            ))}
          </div>
        </header>
        {!compare && (
          <>
            <Button
              customIcon={<InfoIcon />}
              variant="link"
              className={`${styles.link} p-0 text-decoration-link`}
              size="sm"
              onClick={() => setShowInfo(!showInfo)}
            >
              <FormattedMessage
                id="ECG_DETAILS.ELECTRODES.IMPROVE_CONNECTIVITY"
                defaultMessage="How to improve electrodes connectivity"
              />
              ?
            </Button>
            <Collapse in={showInfo} timeout={200}>
              <div className="mt-1">
                <FormattedMessage
                  id="MEASUREMENTS.ELECTRODES.IMPROVE_INFO"
                  defaultMessage="Verify that the round Right arm electrode is in the right arm pit and that the square Waist electrode is at the belt line halfway between the navel and left hip. Repeat transmission."
                />
              </div>
            </Collapse>
          </>
        )}
      </div>
    </MetaCard>
  );
};

export default Electrodes;
